const ProductMainText = () => {
  return (
    <div>
      <p>Kedves Vendégek!</p>
      <section>
        Szeretnénk felhívni figyelmüket, hogy a műköröm építést, géllakkozást és
        anyag eltávolítást kizárólag szakemberrel végeztessék el. Ellenkező
        esetben számos probléma merülhet fel, mint például:
      </section>
      <p>Köröm betegségek:</p>
      <div className="product_text_section">
        <li>
          Szürke köröm- Pseudomonas Bacterial. A körömlemez elválik a
          körömágytól, így könnyen baktériumok telepednek alatta.
        </li>
        <li>Körömlemez elszíneződése.</li>
        <li>Fehér pontok a körmön – Leukonychia</li>
        <li>Fertőző gomba – Onychomycosis</li>
        <li>Töredező köröm – Onychorrhexis</li>
        <li>Körömsánc gyulladás</li>
        <li>Repedezett köröm</li>
        <p>
          A felsorolt betegségek csak néhány példa arra, milyen problémák
          léphetnek fel, ha nem szakember végzi a kezeléseket.
        </p>
        <p>
          A Lakk Szépségszalonban kizárólag egészséges körmöket vállalunk, mivel
          nem gyógyítunk betegségeket. Az első látogatás alkalmával diagnózist
          készítünk, melyet kezelési lapon rögzítünk. Ezt követően egy egyedi
          kezelési tervet állítunk össze, amely a köröm állapotától függ. Ha
          bármilyen kérdésük van, nyugodtan forduljanak hozzánk, szívesen adunk
          tanácsokat is.
        </p>
        <br></br>
        <span>
          A Lakk Szépségszalonban készpénzel és bankkártáyával egyaránt
          fizethet.
        </span>
      </div>
    </div>
  );
};

export default ProductMainText;
